import { Link } from "react-router-dom";
import { ranking, stats } from "@/mocks/gossip";
import SectionTitle from "@/components/base/SectionTitle";

const tagStyle: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  热: "bg-accent-500 text-foreground-950",
  新: "bg-secondary-500 text-background-50",
  荐: "bg-background-200 text-foreground-700",
};

export default function RankingSection() {
  const maxHeat = Math.max(...ranking.map((r) => r.heat));

  return (
    <section id="rank" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="Trending"
          title="热瓜榜"
          desc="综合浏览量、讨论量与传播速度实时计算，每小时更新一次。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <ol className="lg:col-span-8 bg-background-50 border border-background-200 rounded-lg divide-y divide-background-200">
            {ranking.map((item, index) => (
              <li key={item.id}>
                <Link
                  to={`/article/${item.id}`}
                  className="group flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-primary-50/50 transition-colors"
                >
                  <span
                    className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center font-heading font-bold text-base ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="flex items-center gap-2">
                      <span
                        className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-label ${tagStyle[item.tag] || tagStyle["荐"]}`}
                      >
                        {item.tag}
                      </span>
                      <span className="font-heading text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
                        {item.title}
                      </span>
                    </span>
                    <span className="mt-2 flex items-center gap-3">
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
                      <span className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                        <span
                          className="block h-full rounded-full bg-accent-500"
                          style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                        ></span>
                      </span>
                      <span className="text-xs font-label text-primary-600 whitespace-nowrap">
                        {item.heat}
                      </span>
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ol>

          <div className="lg:col-span-4 flex flex-col gap-4">
            <div className="rounded-lg bg-primary-950 text-background-100 p-6">
              <h3 className="font-heading text-lg font-semibold text-background-50">平台数据一览</h3>
              <p className="mt-2 text-sm text-background-300 leading-relaxed">
                持续整理画面与时间线，让每一次吃瓜都有据可查。
              </p>
              <div className="mt-6 grid grid-cols-2 gap-4">
                {stats.map((stat) => (
                  <div key={stat.label} className="rounded-lg bg-background-50/10 border border-background-50/15 p-4">
                    <span className="w-8 h-8 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center text-lg">
                      <i className={stat.icon} aria-hidden="true"></i>
                    </span>
                    <p className="mt-3 font-heading text-xl font-bold text-background-50">{stat.value}</p>
                    <p className="text-xs text-background-300 mt-0.5">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h3 className="font-heading text-base font-semibold text-foreground-900">投稿与线索</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                拍到现场画面？欢迎通过页面底部邮箱投稿，注明时间与地点，我们会先核验再收录。
              </p>
              <Link
                to="/about"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                了解内容原则
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}